// test1244
(1244 && 0);
